import './first_metrics/first_metrics_chart_view.js.coffee'

Namespace 'CustomerVisualMode.Charts'

CHARTS = CustomerVisualMode.Charts

class CustomerVisualMode.Charts.FirstMetricsCalculatedInRange extends CHARTS.FirstMetricsChartView
  @NAME: 'first_metrics_calculated_in_range'

  initialize: ({widget, data, session, isReadOnly, isResponsive}) ->
    title = @_getTitle()
    description = I18n.t('customer_visual_mode.charts.first_metrics_calculated_in_range.description')
    super({widget, title, description, data, session, isReadOnly, isResponsive})

  _getTitle: ->
    @_workCalendarStrategy(
      I18n.t('customer_visual_mode.charts.first_metrics_calculated_in_range.title'),
      I18n.t('customer_visual_mode.charts.first_metrics_calculated_in_range.title_without_work_calendar'))
